import React, { useState, useEffect, useRef } from 'react';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Typography from '@mui/material/Typography';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
// import { toast } from 'react-toastify';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import { Card } from '@mui/material';
import type { Icons } from '../../../types/icons';
// import { StylediconDataCard } from '../ThemeComponent';
// import { deleteIcon } from '../../../services/api/OttIcon';

interface iconDataCardProps {
	iconData: Icons;
	onClick: (iconData: Icons) => void;
	// fetchCategories: () => Promise<void>;
}

interface HandleEditProps {
	(iconData: Icons): void;
}

// const IconCard: React.FC<iconDataCardProps> = ({ iconData, onClick, fetchCategories }) => {
const IconCard: React.FC<iconDataCardProps> = ({ iconData, onClick }) => {
	const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
	const open = Boolean(anchorEl);
	const [showFullDescription, setShowFullDescription] = useState(false);
	const [showReadMore, setShowReadMore] = useState(false);
	const descriptionRef = useRef<HTMLDivElement>(null);

	const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
		setAnchorEl(event.currentTarget);
	};

	const handleMenuClose = () => {
		setAnchorEl(null);
	};

	const handleEdit: HandleEditProps = (iconData) => {
		onClick(iconData);
		handleMenuClose();
	};

	// const handleDelete = async () => {
	// 	const confirmToastId = toast(
	// 		<div>
	// 			<p>Are you sure you want to delete this product?</p>
	// 			<button
	// 				onClick={async () => {
	// 					toast.dismiss(confirmToastId);
	// 					try {
	// 						const response = await deleteIcon(iconData?._id);
	// 						if (response.success) {
	// 							toast.success(response.data.message);
	// 							fetchCategories();
	// 						}
	// 					} catch (error) {
	// 						toast.error('Failed to delete iconData');
	// 					} finally {
	// 						handleMenuClose();
	// 					}
	// 				}}
	// 				style={{
	// 					marginRight: '10px',
	// 					padding: '5px 10px',
	// 					background: 'red',
	// 					color: 'white',
	// 					border: 'none',
	// 					cursor: 'pointer',
	// 				}}
	// 				type="button"
	// 			>
	// 				Yes
	// 			</button>
	// 			<button
	// 				onClick={() => toast.dismiss(confirmToastId)}
	// 				style={{
	// 					padding: '5px 10px',
	// 					background: 'gray',
	// 					color: 'white',
	// 					border: 'none',
	// 					cursor: 'pointer',
	// 				}}
	// 				type="button"
	// 			>
	// 				No
	// 			</button>
	// 		</div>,
	// 		{ autoClose: false, closeOnClick: false }
	// 	);
	// };

	const toggleDescription = () => {
		setShowFullDescription(!showFullDescription);
		if (descriptionRef.current) {
			descriptionRef.current.style.maxHeight = showFullDescription
				? '60px'
				: `${descriptionRef.current.scrollHeight}px`;
		}
	};

	useEffect(() => {
		if (descriptionRef.current) {
			setShowReadMore(
				descriptionRef.current.scrollHeight > descriptionRef.current.clientHeight
			);
		}
	}, [iconData]);

	return (
		// <StylediconDataCard>
		<Card>
			<div style={{ position: 'relative' }}>
				<CardMedia
					onClick={() => onClick(iconData)}
					component="img"
					height="100"
					image={
						typeof iconData?.imageUrl === 'string'
							? iconData?.imageUrl
							: iconData?.imageUrl
								? URL.createObjectURL(iconData?.imageUrl)
								: ''
					}
					alt={iconData?.name}
					style={{ objectFit: 'contain' }}
				/>
				<IconButton
					aria-label="more"
					aria-controls="long-menu"
					aria-haspopup="true"
					onClick={handleMenuClick}
					style={{ position: 'absolute', top: 0, right: 0 }}
				>
					{anchorEl ? <MoreVertIcon /> : <MoreHorizIcon />}
				</IconButton>
			</div>
			<CardContent sx={{ paddingBottom: '16px!important' }}>
				<Typography
					gutterBottom
					component="div"
					style={{
						fontFamily: 'Poppins',
						fontWeight: '400',
						fontSize: '12px',
						whiteSpace: 'nowrap',
						overflow: 'hidden',
						textOverflow: 'ellipsis',
					}}
				>
					{iconData.name}
				</Typography>
				{showReadMore && (
					<Typography
						variant="body2"
						color="primary"
						onClick={toggleDescription}
						style={{
							cursor: 'pointer',
							fontFamily: 'Poppins',
							fontWeight: '500',
							fontSize: '12px',
						}}
					>
						{showFullDescription ? 'Read Less' : 'Read More'}
					</Typography>
				)}

				<Menu
					id="long-menu"
					anchorEl={anchorEl}
					open={open}
					onClose={handleMenuClose}
					slotProps={{
						paper: {
							style: {
								maxHeight: 48 * 4.5,
								width: '20ch',
								fontFamily: 'Poppins',
								paddingBottom: '0px',
								paddingTop: '0px',
							},
						},
					}}
					className="product-card-menu"
				>
					<MenuItem
						onClick={() => handleEdit(iconData)}
						sx={{ fontFamily: 'Poppins', '&:hover': { color: '#fff' } }}
					>
						Edit
					</MenuItem>
					{/* <MenuItem
						onClick={handleDelete}
						sx={{ fontFamily: 'Poppins', '&:hover': { color: '#fff' } }}
					>
						Delete
					</MenuItem> */}
				</Menu>
			</CardContent>
		</Card>
	);
};

export default IconCard;
